// Aparência da planilha exportada (cor, fonte, zebra, totais, topo). Cada usuário guarda a sua neste navegador;
// vai junto em toda exportação (campo "estilo"), e o backend (PlanilhaPadrao.Estilo) valida de novo.

export const CORES_PLANILHA = [
    { id: "azul", nome: "Azul", cor: "#1F3864" },
    { id: "petroleo", nome: "Petróleo", cor: "#0F5E66" },
    { id: "verde", nome: "Verde", cor: "#1E5631" },
    { id: "grafite", nome: "Grafite", cor: "#3A3F4B" },
    { id: "vinho", nome: "Vinho", cor: "#7B1E3A" },
    { id: "laranja", nome: "Laranja", cor: "#B45309" },
    { id: "roxo", nome: "Roxo", cor: "#4A2C82" },
];

export const FONTES_PLANILHA = ["Calibri", "Arial", "Segoe UI", "Verdana", "Tahoma", "Cambria", "Times New Roman", "Courier New"];
export const TAMANHOS_FONTE = [9, 10, 11, 12, 14];

export const ESTILO_PADRAO = { cor: "#1F3864", fonte: "Calibri", tamanhoFonte: 11, zebrado: false, totais: true, topo: true };

const chave = () => {
    let usuario = "anonimo";
    try {
        usuario = sessionStorage.getItem("userId") || usuario;
    } catch (e) {
        // sem sessionStorage: chave genérica
    }
    return `ral:estiloPlanilha:${usuario}`;
};

/** Mesmas regras do backend: cor #RRGGBB, fonte da lista, tamanho de 8 a 16. */
export function normalizarEstilo(e) {
    const base = e || {};
    const cor = typeof base.cor === "string" && /^#?[0-9a-fA-F]{6}$/.test(base.cor.trim())
        ? `#${base.cor.trim().replace("#", "").toUpperCase()}` : ESTILO_PADRAO.cor;
    const tamanho = Number(base.tamanhoFonte);
    return {
        cor,
        fonte: FONTES_PLANILHA.includes(base.fonte) ? base.fonte : ESTILO_PADRAO.fonte,
        tamanhoFonte: Number.isFinite(tamanho) ? Math.max(8, Math.min(16, Math.round(tamanho))) : ESTILO_PADRAO.tamanhoFonte,
        zebrado: typeof base.zebrado === "boolean" ? base.zebrado : ESTILO_PADRAO.zebrado,
        totais: typeof base.totais === "boolean" ? base.totais : ESTILO_PADRAO.totais,
        topo: typeof base.topo === "boolean" ? base.topo : ESTILO_PADRAO.topo,
    };
}

export function carregarEstilo() {
    try {
        const salvo = localStorage.getItem(chave());
        return salvo ? normalizarEstilo(JSON.parse(salvo)) : { ...ESTILO_PADRAO };
    } catch (e) {
        return { ...ESTILO_PADRAO };
    }
}

export function salvarEstilo(estilo) {
    try {
        localStorage.setItem(chave(), JSON.stringify(normalizarEstilo(estilo)));
    } catch (e) {
        // navegador sem armazenamento: vale só até fechar a tela
    }
}

export const estiloPadrao = (estilo) => JSON.stringify(normalizarEstilo(estilo)) === JSON.stringify(ESTILO_PADRAO);

const canal = (v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
};

const rgb = (hex) => {
    const h = normalizarEstilo({ cor: hex }).cor.replace("#", "");
    return [0, 2, 4].map(i => parseInt(h.substring(i, i + 2), 16));
};

/** Texto legível sobre a cor (igual ao do backend): quase preto em cor clara, branco em cor escura. */
export function textoSobre(cor) {
    const [r, g, b] = rgb(cor);
    const luz = 0.2126 * canal(r) + 0.7152 * canal(g) + 0.0722 * canal(b);
    return luz > 0.45 ? "#1A1A1A" : "#FFFFFF";
}

/** Cor clareada (0 = a própria, 1 = branco): zebra (0.88) e linha de totais (0.92), como na planilha. */
export function clarear(cor, quanto) {
    return `#${rgb(cor).map(c => Math.round(c + (255 - c) * quanto).toString(16).padStart(2, "0")).join("").toUpperCase()}`;
}

export const nomeDaCor = (cor) => CORES_PLANILHA.find(c => c.cor === normalizarEstilo({ cor }).cor)?.nome || "Personalizada";
